import React from 'react'
import linkStyles from './Footer.module.css'
import {Link} from 'react-router-dom'
import {Button} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import tiling from '../../images/blue-tile.png'
import vouchersbackground from '../../images/vouchers-background.jpg'
import voucherscenter from '../../images/voucher-center.jpg'
import voucheravailable from '../../images/gift-voucher-available.png'
import giftcards from '../../images/gift-cards.png'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { Box, Typography } from '@mui/material';
let specialhours = "https://www.google.com/search?q=diablo+escapes+walnut+creek+hours&sxsrf=AJOqlzVr9bBM3Vp3zLxJxmOcmY281duueA%3A1673493426718&ei=snu_Y-jBK4KIkPIPmqem4AI&ved=0ahUKEwjo4u7piMH8AhUCBEQIHZqTCSwQ4dUDCA8&uact=5&oq=diablo+escapes+walnut+creek+hours&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzIFCCEQoAEyBQghEKsCOgoIABBHENYEELADOg0IABBHENYEEMkDELADOggIABCSAxCwAzoLCC4QgAQQxwEQrwE6AggmSgQIQRgASgQIRhgAUN0DWKkKYM8MaAFwAXgAgAGcAYgBuQWSAQMyLjSYAQCgAQHIAQnAAQE&sclient=gws-wiz-serp"

export const Footer = () => {
  
  return (
    <Grid container spacing={0} paddingTop={5} style={{backgroundImage:`url(${tiling})`, backgroundAttachment:"fixed"}}>
        <Grid item xs={4}  position={"relative"} display={{xs:"none", sm:"flex"}} justifyContent="center">
          <img src={vouchersbackground} style = {{width:"100%", height:"100%"}} alt = "background hue"/>
          <img src={voucheravailable} height="80%" style = {{position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", }} alt = "voucheravailable"/>
        </Grid>
        <Grid item xs={12} sm={4} position={"relative"} display={{xs:"flex"}}>
          <img src={voucherscenter} style = {{ width:"100%", height:"100%"}} alt = "background hue"/>
          <Link reloadDocument to = "/Vouchers">
            <Button style={{position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", backgroundColor:"#2b388f", borderRadius:"20px"}}>
              Gift an Adventure</Button>
          </Link>
        </Grid>
        <Grid item xs={4} position={"relative"} display={{xs:"none", sm:"flex"}}>
          <img src={vouchersbackground} style = {{ width:"100%", height: "100%"}} alt = "background hue"/>
          <img src={giftcards} height = "80%" style = {{position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)"}} alt = "gift cards"/>
        </Grid>

        <Grid item xs={12} md={4} padding={5} display="flex" justifyContent="center" color="white" className={linkStyles.footer}>
          <Box>
           <Typography fontFamily={"Sans-Serif"}>
            <a href="https://www.google.com/maps/place/Diablo+Escapes/@37.8980154,-122.069794,17z/data=!4m5!3m4!1s0x808561edc967c1a1:0x123f58a04af6faff!8m2!3d37.8980112!4d-122.0676053">
            <LocationOnIcon color="primary"/>
            1948 Mount Diablo Blvd<br/> &emsp;&nbsp; Walnut Creek, CA 94597 
            </a>
           </Typography><br/>
           <Typography fontFamily={"Sans-Serif"}>
            <a href="tel: 925-393-7171"><PhoneIcon/> (925)-393-7171</a>
            </Typography> <br/>
           <Typography fontFamily={"Sans-Serif"}>
            <a href="mailto: info@diabloescapes.com"> <EmailIcon/> info@diabloescapes.com</a>
            </Typography><br/>
           <Typography fontFamily={"Sans-Serif"}>
          <table>
            <tr>
              <th style={{width:"25%"}}></th>
              <th></th>
            </tr>
            <tr>
              <td>Sun:</td>
              <td>10AM - 10:30PM</td>
            </tr>
            <tr>
              <td>Mon:</td>
              <td>Closed*</td>
            </tr>
            <tr>
              <td>Tue:</td>
              <td>1PM - 10PM</td>
            </tr>
            <tr>
              <td>Wed:</td>
              <td>1PM - 10PM</td>
            </tr>
            <tr>
              <td>Thu:</td>
              <td>1PM - 10PM</td>
            </tr>
            <tr>
              <td>Fri:</td>
              <td>11:30AM - 11:30PM</td>
            </tr>
            <tr>
              <td>Sat:</td>
              <td>10AM - 11:30PM</td>
            </tr>
        </table> 
        *open on select Mondays <br/><br/>
        <Box display={{xs:"none", md:"flex"}}>
          <Button  target = "_blank" href={specialhours} variant="outlined"  style={{transform:"translate(-3%,0%)", borderRadius:"20px", color:"white"}}><Typography fontFamily={"Copperplate"}>Today's Hours</Typography></Button>
        </Box>
        <Box display={{xs:"flex", md:"none"}}>
          <Button  target = "_blank" href={specialhours} variant="outlined"  style={{transform:"translate(1%,0%)", borderRadius:"20px", color:"white"}}><Typography fontFamily={"Copperplate"}>Today's Hours</Typography></Button>
        </Box>
        </Typography>
        </Box>
        </Grid>
        <Grid  item xs={12} md={4} padding={5} textAlign="center">
          <Button component = {Link} reloadDocument to ="/VR" variant="contained"  style={{borderRadius:"20px", color:"black"}}><Typography fontFamily={"Copperplate"}>Book Now</Typography></Button>
        </Grid>
        <Grid item xs={12} md={4} padding={5} paddingBottom={0}>  
          <iframe title="Google Maps Embed" style={{border:0, width:"100%", height:"350px"}} loading="lazy" allowFullScreen src="https://www.google.com/maps/embed/v1/search?q=Diablo%20Escapes%2C%20Mount%20Diablo%20Boulevard%2C%20Walnut%20Creek%2C%20CA%2C%20USA&key=AIzaSyDxm5ixpw3-KJAZmpFsCHn5TbOYHI-Djt4"></iframe> 
        </Grid>
        <Grid xs ={12} display="flex" justifyContent={"center"}>
          <Typography color="white" fontFamily={"Sans-Serif"}>Ⓒ 2022-2023 Diablo Escapes </Typography>
        </Grid>
    </Grid>
    )
}
